import * as React from "react";
import { Helmet } from "react-helmet";

// Components
import PageWrapper from "../../Components/Layouts/PageWrapper";
import SignUpWrapper from "../../Components/Layouts/SignUpWrapper";

import SignUpForm from "./SignUpForm";

export default class Login extends React.Component {
  render() {
    return (
      <PageWrapper>
        <SignUpWrapper>
          <SignUpForm />
        </SignUpWrapper>
        <Helmet title="Sign Up" />
      </PageWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/SignUp/index.tsx